module.exports = __webpack_public_path__ + "static/contactBcg-ee3568a3215956325b587968801cef37.jpeg";